import { Component, Input, Output, EventEmitter, ElementRef, OnChanges } from '@angular/core';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  styleUrl: './text-area.component.scss',
})
export class TextAreaComponent implements OnChanges {
  @Input('model') textdata: string;
  @Input('disable') isDisabled: boolean;
  @Input() placeHolderText: string;
  @Input('require') isRequired: boolean;
  @Input() row: number;
  @Output() onBlur: EventEmitter<any> = new EventEmitter();
  @Output() saveText = new EventEmitter<any>();

  constructor(private elementRef: ElementRef) {}

  ngOnChanges() {
    setTimeout(() => {
      document.getElementById('textAreaNew').style.height = document.getElementById('textAreaNew').scrollHeight + 'px';
    });
  }

  public textChange() {
    setTimeout(() => {
      document.getElementById('textAreaNew').style.height = document.getElementById('textAreaNew').scrollHeight + 'px';
      this.saveText.emit(this.textdata);
    });
  }

  public offFocus() {
    this.onBlur.emit();
  }
}
